export const ORG_ID =
  process.env.PAUSE_ORG || process.env.NODE_ENV === 'development'
    ? 'gentry'
    : 'ransomedheart'
export const DEFAULT_ORG_PATH = `organizations/${ORG_ID}`
export const DEFAULT_USERS_PATH = 'users'
export const DEFAULT_ORG_PAUSES_PATH = `${DEFAULT_ORG_PATH}/pauses`
export const DEFAULT_ORG_V2_PAUSES_PATH = `${DEFAULT_ORG_PATH}/v2pauses`
export const DEFAULT_ORG_PROGRAMS_PATH = `${DEFAULT_ORG_PATH}/programs`
